<template>
  <div class="services__item">
    <div class="item__header" tabindex="0" @click="togglePopup">
      <div class="item__icon"><img :src="item.icon" :alt="item.title" /></div>
      <h4 class="item__title">{{ item.title }}</h4>
    </div>
    <div class="item__description" v-html="item.content"></div>
    <p class="item__more" @click="togglePopup">Ver más</p>
    <Popup
      v-if="openedPopup"
      class="popup__container--small"
      :title="item.title"
      :showCloseIcon="true"
      :cta="item.cta"
      @closePopup="togglePopup"
    >
      <div class="item__content" v-html="item.content"></div>
    </Popup>
  </div>
</template>
<script>
import Popup from '@/funnels/components/layout/Popup';

export default {
  components: { Popup },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openedPopup: false,
    };
  },
  computed: {},
  methods: {
    togglePopup() {
      this.openedPopup = !this.openedPopup;
    },
  },
};
</script>
